import _ from "lodash";
import { Label } from "reactstrap";

const FormEntry = ({
	formLabel,
	placeholder,
	type = "text",
	appendText,
	error,
	register = () => {},
	editable = true,
	name,
	required = false,
	additionalOptions = {},
	validation = {},
	transformations = {},
	light = false,
	readOnly = false,
	disabled = false,
	alt = "",
	prefix = "",
	labelEditable = false,
	setValueAs = (value) => value,
	labelPlaceholder = "",
	labelInputName,
	defaultValue,
	labelType = "text",
	labelSize = "sm",
	step = "0.5",
	marginClass = "",
	min = null,
	labelSplit = false,
	labelInputRequired = false,
	labelInputTitle = "",
	labelInputError,
	noLabel = false,
	max = null,
}) => {
	return editable ? (
		<div className={`${marginClass ? marginClass : "mb-3"} w-100`}>
			<div className={`${noLabel || labelSplit ? "form-group" : "input-group"} ${marginClass}`}>
				{!noLabel &&
					(labelSplit ? (
						<Label className="text-white ml-3">{formLabel}</Label>
					) : (
						<div className="input-group-prepend position-relative" style={disabled || readOnly ? { backgroundColor: "#1D253B" } : {}}>
							{labelEditable ? (
								<input
									className={`input-group-text form-control hide-scrollbar text-left ${light && "text-dark"} ${
										labelInputError && "is-invalid"
									}`}
									type={labelType}
									style={{ borderLeft: "1 1" }}
									{...register((prefix ? `${prefix}.` : "") + labelInputName, {
										required: labelInputRequired
											? {
													value: true,
													message: `${labelInputTitle} is required`,
											  }
											: false,
									})}
									placeholder={labelPlaceholder}
								/>
							) : (
								<span className={`input-group-text hide-scrollbar px-3 ${light && "text-dark"}`}>{formLabel}</span>
							)}
						</div>
					))}
				<input
					type={type}
					{...(type === "number" ? { step } : {})}
					{...(type === "time" ? { step: step === "0.5" ? "1800" : step } : {})}
					placeholder={placeholder}
					className={`form-control ${Boolean(error) && "is-invalid"} ${readOnly && "text-light"}`}
					defaultValue={defaultValue}
					autoCapitalize="none"
					{...(min !== null && { min })}
					{...(max !== null && { max })}
					{...register((prefix ? `${prefix}.` : "") + name, {
						valueAsNumber: type === "number",
						required: required
							? {
									value: true,
									message: `${formLabel || "Field"} is required`,
							  }
							: false,
						setValueAs: (value) => {
							if (_.isNull(value)) return null;
							return setValueAs(value);
						},
						...validation,
						...transformations,
						...additionalOptions,
					})}
					disabled={disabled || readOnly}
				/>
				{appendText && (
					<div className="input-group-append">
						<span className="input-group-text">{appendText}</span>
					</div>
				)}
			</div>
			{labelInputError && (
				<div className="text-center">
					<small className="text-danger">{labelInputError?.message}</small>
				</div>
			)}
			{error && (
				<div className="text-center">
					<small className="text-danger">{error?.message}</small>
				</div>
			)}
		</div>
	) : (
		<div className="mb-3 w-100">
			<div className="row">
				<div
					className={`${light && "text-dark"} ${
						labelSize === "lg" ? "col-sm-4 col-md-4" : "col-sm-4 col-md-3"
					} text-left mb-1 text-light font-weight-bold`}
				>
					{formLabel}
				</div>
				<div className={`text-info ${labelSize === "lg" ? "col-sm-8 col-md-8" : "col-sm-8 col-md-9"}`}>{alt}</div>
			</div>
		</div>
	);
};

export default FormEntry;
